import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ClickOutsideDirective } from '../../directives/click-outside.directive';

@Component({
  selector: 'app-dropdown-search',
  standalone: true,
  imports: [FormsModule, CommonModule, ClickOutsideDirective],
  templateUrl: './dropdown-search.component.html',
  styleUrl: './dropdown-search.component.scss'
})
export class DropdownSearchComponent {
  @Input() items: { _id: string; name: string; description: string }[] = [];
  @Input() label: string = '';
  @Input() error: string = '';
  @Output() selectedItem = new EventEmitter<{ _id: string; name: string }>();

  searchQuery: string = '';
  dropdownOpen: boolean = false;
  selectedTitle: string = '';
  filteredItems: { _id: string; name: string; description: string }[] = [];

  ngOnInit() {
    this.filteredItems = [...this.items];
  }

  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
  }
  close(){
    this.dropdownOpen = false;
  }

  filterItems() {
    const query = this.searchQuery.toLowerCase();
    this.filteredItems = this.items.filter((item) =>
      item.name.toLowerCase().includes(query)
    );
  }

  selectItem(item: { _id: string, name: string }) {
    this.selectedTitle = item.name;
    this.selectedItem.emit(item);
    this.dropdownOpen = false;
    this.searchQuery = '';
    this.filteredItems = [...this.items];
  }
}
